'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import RaceMap from './RaceMap';
import ElevationChart from './ElevationChart';

export default class RaceGraphics extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    id: PropTypes.string.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      pos: [this.props.data[0].lat, this.props.data[0].lng],
    }
  }

  moveCursor = (index) => {
    const lat = this.props.data[index].lat;
    const lng = this.props.data[index].lng;
    this.setState({ pos: [lat, lng] })
  }

  render() {
    return (
      <div>
        <RaceMap
          data={this.props.data}
          markerPos={this.state.pos} />
        <ElevationChart
          data={this.props.data}
          routeId={this.props.id}
          moveCursor={this.moveCursor} />
      </div>
    );
  }
}
